'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var Send = require('../../../IconsAndImages/Icons/Send.js');
var IconButton = require('../../Inputs/Buttons/IconButton.js');
var TextField = require('../../Inputs/TextFields/TextField.js');
var InputAdornment = require('../../../node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ChatResponse = function ChatResponse(props) {
  return React__default["default"].createElement(TextField["default"], _objectSpread({
    fullWidth: true,
    multiline: true,
    border: "round",
    InputProps: {
      endAdornment: React__default["default"].createElement(InputAdornment["default"], {
        position: "end"
      }, React__default["default"].createElement(IconButton, {
        size: "small"
      }, React__default["default"].createElement(Send, {
        color: "primary",
        height: 22,
        width: 22
      })))
    }
  }, props));
};

module.exports = ChatResponse;
